<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm"
                @search="search" />
      <TransferForm ref="transferForm"
                    @calc="calc" />
      <OrderInfoForm ref="orderInfoForm"
                     @getComputeInfo="getComputeInfo" />
      <IncomeForm ref="incomeForm" />
      <DispatchForm ref="dispatchForm"
                    @setFollowUpLocal="setFollowUpLocal" />
      <SettlementForm ref="settlementForm" />
      <FollowUpForm ref="followUpForm"
                    @setDispatchFollowUpLocal="setDispatchFollowUpLocal" />
      <OtherForm ref="otherForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import TransferForm from './transfer';
import OrderInfoForm from './orderInfo';
import IncomeForm from './income';
import DispatchForm from './dispatch/dispatch';
import SettlementForm from './settlement';
import FollowUpForm from './followUp';
import OtherForm from './other';

import SubBtnBox from 'components/subBtnBox';
import { saveOrder, queryOrderDetail } from 'api/operate';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    TransferForm,
    OrderInfoForm,
    IncomeForm,
    DispatchForm,
    SettlementForm,
    OtherForm,
    FollowUpForm,

    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/distribution/customerOrder/dispatch/edit',
      formComponents: [
        'transferForm',
        'orderInfoForm',
        'incomeForm',
        'dispatchForm',
        'settlementForm',
        'otherForm',
        'followUpForm',
      ],
    };
  },
  computed: {
    detailParams () {
      return {
        orderId: this.$route.query.id,
        ['customerInfo.orderId']: this.$route.query.id,
        ['dispatchInfo.orderId']: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: queryOrderDetail,
    editApi: saveOrder,
    calc () {
      if (this.$refs.orderInfoForm) {
        this.$refs.orderInfoForm.calcOrderDetail({ isAutoSort: false });
      }
    },
    toAddNewAddress () {
      if (this.$refs.baseForm) {
        this.$refs.baseForm.toAddNewAddress();
      }
    },
    search (data) {
      this.$refs.transferForm.setData(data);
    },
    getRightTable () {
      for (let item of this.formComponents) {
        if (this.$refs[item] && this.$refs[item].getRightTable) {
          this.$nextTick(() => {
            if (this.$refs.transferForm.$refs.transferTable) {
              this.$refs[item].getRightTable(this.$refs.transferForm.$refs.transferTable);
            }
          });
        }
      }
    },
    setFollowUpLocal (data) {
      if (this.$refs.followUpForm) {
        this.$refs.followUpForm.setFollowUpForm(data);
      }
    },
    setDispatchFollowUpLocal (data) {
      if (this.$refs.dispatchForm) {
        this.$refs.dispatchForm.setDispatchFollowUpLocal(data);
      }
    },
    getComputeInfo (data) {
      if (this.$refs.incomeForm) {
        this.$refs.incomeForm.setComputeInfo(data);
      }
    },
  },
  async mounted () {
    this.getData();
    this.getRightTable();
  },
};
</script>

<style scoped lang="scss">
</style>
